import * as React from 'react';

import { Text } from '../Text';

import { mergeStyles } from '@cian/utils';
import * as styles from './RadioButton.css';

export interface IRadioButtonProps extends React.HTMLProps<HTMLInputElement> {
  dataMark?: string;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export function RadioButton({ children, ...rest }: IRadioButtonProps) {
  const {
    disabled,
    dataMark = 'RadioButton',
  } = rest;

  return (
    <label
      data-mark={dataMark}
      {...mergeStyles([
        styles['radiobutton'],
        disabled && styles['disabled'],
      ])}
    >
      <input type="radio" {...rest} className={styles['input']}/>
      <div className={styles['icon']}/>
      <Text
        color={disabled ? 'gray_2' : 'black'}
        fontSize={14}
        lineHeight={18}
      >
        {children}
      </Text>
    </label>
  );
}
